export const edboFetchingTypeEnum = {
    applicantList: 0,
    applicantDetail: 1,
};